import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { isTextTruncated } from "@/util/stringUtil";
import { useAgent, useRecentAgents } from "@/query/agent";
import { useRouteHandler } from "@/hook/useRouteHandler";
import Tooltip from "@/component/Tooltip";
import { DropdownGroup, DropdownButton, DropdownFooter, DropdownItem, DropdownItems } from "@/component/input";


const AgentDropdown: React.FC<{agentId: number}> = ({ agentId }) => {
    const intl = useIntl();
    const { moveToAgentList, moveToDashboard } = useRouteHandler();

    const btnTextRef = useRef<HTMLButtonElement>(null);
    const [isTruncated, setIsTruncated] = useState<boolean>(false);

    const { data: agent } = useAgent(agentId);
    const { data: recentAgents } = useRecentAgents();

    const onClickAgent = (agentId: number) => {
        moveToDashboard(agentId);
    };
    const onClickMore = () => {
        moveToAgentList();
    };

    useEffect(() => {
        setIsTruncated(isTextTruncated(btnTextRef.current!));
    }, [agent?.name]);

    return (
        <DropdownGroup width={209} className="z-20">
            <DropdownButton as="div"
                            iconClassName="!size-5"
                            className="w-full outline-0 !py-0 cursor-pointer hover:bg-chat42-10"
            >
                <Tooltip message={agent!.name}
                         placement="bottom-start"
                         disable={!isTruncated}
                         tooltipClassName="-ml-3.5 w-full h-[44px] flex items-center text-[16px] font-[400]"
                >
                    <button ref={btnTextRef}
                            className="w-full h-fit pt-2 pb-1.5 text-chat42 text-[16px] font-[500] text-start truncate"
                    >
                        {agent!.name}
                    </button>
                </Tooltip>
            </DropdownButton>
            <DropdownItems>
                {recentAgents?.map((agent) => (
                    <DropdownItem key={agent.id}
                                  className="popover-item popover-text-400"
                                  onClick={() => onClickAgent(agent.id)}
                    >
                        {agent.name}
                    </DropdownItem>
                ))}

                <DropdownFooter onClick={onClickMore}
                                className="popover-item popover-text-400 border-chat42-50"
                >
                    {intl.formatMessage({ id: 'i00001' })}
                </DropdownFooter>
            </DropdownItems>
        </DropdownGroup>
    );
};

export default AgentDropdown;